export enum LOCAL_STORAGE_KEYS {
	REDIRECT_PATH = 'REDIRECT_PATH',
}
